import { connect } from 'react-redux';
import { GroupEditor } from '../components';

import { addGroup, updateGroup, closeGroupEditor, deleteGroup } from '../actions';

const mapStateToProps = state => ({
  group: state.groupEditor.group,
  isNew: state.groupEditor.isNew,
  tagGroups: state.tagGroups,
});

const mapDispatchToProps = dispatch => (
  {
    closeGroupEditor: () => {
      dispatch(closeGroupEditor());
    },
    addGroup: (group) => {
      dispatch(addGroup(group));
    },
    updateGroup: (group) => {
      dispatch(updateGroup(group));
    },
    deleteGroup: (groupId) => {
      dispatch(deleteGroup(groupId));
    },
  }
);

const GroupModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GroupEditor);

export default GroupModal;



// WEBPACK FOOTER //
// ./src/containers/GroupEditor.js